export default __webpack_public_path__ + "static/media/LabTests.45d09d54.png";